import { LogoutRedirect } from './LogoutRedirect';

document.addEventListener('DOMContentLoaded', function () {
  window.Webflow ||= [];

  window.Webflow.push(async () => {
    const app = new LogoutRedirect();
    app.init();
    document.documentElement.classList.add('webflow-loaded');
  });
});
